import { render, staticRenderFns } from "./Redistribute.vue?vue&type=template&id=4679e5a4"
import script from "./Redistribute.vue?vue&type=script&lang=js"
export * from "./Redistribute.vue?vue&type=script&lang=js"
import style0 from "./Redistribute.vue?vue&type=style&index=0&id=4679e5a4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4679e5a4')) {
      api.createRecord('4679e5a4', component.options)
    } else {
      api.reload('4679e5a4', component.options)
    }
    module.hot.accept("./Redistribute.vue?vue&type=template&id=4679e5a4", function () {
      api.rerender('4679e5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Gravame/Redistribute.vue"
export default component.exports